import type { Option } from "@dndbeyond/ttui/lexicon/components/Dropdown";

/**
 * Maps search param values (e.g. `?class=Wizard&class=rogue`) to the matching
 * dropdown options. Matching is case-insensitive, values with no matching
 * option are ignored, and duplicates are dropped.
 */
export const optionsFromParams = (
  values: Array<string>,
  options: Array<Option>
): Array<Option> => {
  const matches: Array<Option> = [];
  values.forEach((value) => {
    const normalized = value.trim().toLowerCase();
    const match = options.find(
      (option) => String(option.value).toLowerCase() === normalized
    );
    if (match && !matches.includes(match)) matches.push(match);
  });
  return matches;
};
